import { __rest } from "tslib";
import React from 'react';
import { CircularProgress, LinearProgress, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { reactStyling, tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles((theme) => {
    const { progressIndicatorLinear, progressIndicatorLinearInverse } = reactStyling(theme.tokens);
    return {
        progressIndicatorLinear,
        inverse: Object.assign(Object.assign({}, progressIndicatorLinearInverse), { 
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiLinearProgress-barColorPrimary`]: {
                backgroundColor: tokens.inverseInteractive01,
            } }),
        circularProgress: {
            // @ts-ignore
            [`& .${window.CLASSNAME_PREFIX}-MuiCircularProgress-colorPrimary`]: {
                color: tokens.inverseInteractive01,
            },
        },
    };
});
export const ProgressIndicator = (_a) => {
    var { progress, variant, inverse = false } = _a, otherProps = __rest(_a, ["progress", "variant", "inverse"]);
    const classes = useStyles();
    return variant === 'circular' ? (React.createElement(CircularProgress, Object.assign({ className: clsx(classes.circularProgress) }, otherProps))) : (React.createElement(LinearProgress, Object.assign({ className: clsx(classes.progressIndicatorLinear, inverse ? classes.inverse : {}), variant: !!progress ? 'determinate' : 'indeterminate', value: progress }, otherProps)));
};
